import React, { useRef,useState } from "react";
import { nanoid } from 'nanoid'
import { message } from "antd";
import RustRedEditor from "@/component/rust-red-editor";
import useEditorStore from "@/store/useEditorStore";
import useWscCustomFormModal from '@/component/UseWscCustomForm';
import Palette from "./palette";

function FlowEditor({ flow }) {
  
  const addNode = useEditorStore.use.addNode();
  const registerNodes = useEditorStore.use.registerNodes();
  const updateNodeProps = useEditorStore.use.updateNodeProps();
  const dorpRef = useRef(null);
  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const loading = useEditorStore.use.loading();

  const [formid,setFormId] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {

    const t1 = dorpRef.current;
    e.preventDefault();

    // 获取鼠标相对于视口的位置
    const x = e.clientX;
    const y = e.clientY;

    // 获取div相对于视口的位置
    const divRect = e.target.getBoundingClientRect();
    const divLeft = divRect.left;
    const divTop = divRect.top;
    // 获取拖拽源的偏移量
    const nodeType = e.dataTransfer.getData('nodeType');
    let targetNode = registerNodes.find(item => item.type == nodeType);
    // 计算鼠标相对于div的位置
    const relX = x - divLeft;
    const relY = y - divTop;

    addNode({...targetNode,...{
      "id": nanoid(),//"869da9dbcabdc1bf",
      "tosidebar": true,
      "console": true,
      "tostatus": false,
      "complete": "true",
      "targetType": "full",
      "statusVal": "",
      "statusType": "auto",
      "x": relX,
      "y": relY,
      "wires": []
    }});
    // 处理放置事件的逻辑
  };

  const onDbClick= (node) => {
    if(!node.formid) message.error({content:"节点注册信息缺失FormId"});
    else {
      setFormId(node.formid);
      showDynamicModal(node.formid,node);
    }
  }

  return (
    <div className="flex">
      <div className="flex-none">
        <Palette/>
      </div>
      <div
        ref={dorpRef}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        className="border-solid border-2 border-pink-900 h-full overflow-auto"
        style={{ 
          minWidth: "500px", 
          width: "100%",
          height: "calc(100vh - 8rem)",
          position: "relative"
        }}
      >
        <RustRedEditor flow={flow} onDbClick={onDbClick} />
      </div>
      {formid ? (
        <WscCustomFormModal
          formId={formid}
          OnPayload={(form, name, payload) => {
            console.log(form, name, payload);
            switch (name) {
              case "OK": {
                updateNodeProps(payload);
                hide(formid);
              }
              default: {
                hide(formid);
              }
            }
          }}
        />
      ) : null}
    </div>
  );
}

export default FlowEditor;